import { useGlobalAppState } from '@order/GlobalAppState';

export const usePdpV2QueryEnabled = () => {
  const { dynamicFeatureFlags } = useGlobalAppState();

  return dynamicFeatureFlags.isPdpV2QueryEnabled;
};
